<div [formGroup]="form">
  <label
    for="{{ item.formControlName }}"
    class="custom-form-field__label"
  >{{ item.label }}</label>
  <p-password
    [feedback]="false"
    [toggleMask]="true"
    [placeholder]="item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : ''"
    [formControlName]="item.formControlName"
  ></p-password>
</div>
